// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Video */
.videosubnav {
  margin-right: 2rem;
}
.videosubnav .activesn {
  background-color: #1e2c5f;
  color: white;
}

.videocate {
  display: flex;
  font-size: 3rem;
  color: white;
  width: 100%;
}

.cpacate {
  background-color: #152046;
}

.cmacate {
  background-color: #2B418E;
}

.eacate {
  background-color: #0abd5a;
}

.cateitem {
  color: #242424;
  font-size: 1rem;
  list-style-type: none;
}

.cateitem li {
  list-style-type: none;
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}

.cateitem ul {
  padding-left: 0;
  margin: auto;
}

.videotitle {
  font-size: 1.2rem;
  color: #000000;
  font-weight: 700;
}

.videotext {
  font-size: 12pt;
  color: #000000;
}

.speacher {
  font-size: 1rem;
  color: #000000;
}

@media (max-width: 1200px) {
  .mvarea {
    justify-content: center;
  }
  .videocate {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  }
  .mvideocard {
    width: 80%;
  }
  .videosubnav {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/video/styles/video.scss"],"names":[],"mappings":"AAAA,UAAA;AACA;EACI,kBAAA;AACJ;AAAI;EACI,yBAAA;EACA,YAAA;AAER;;AACA;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,yBAAA;AAKJ;;AAHA;EACI,cAAA;EACA,eAAA;EACA,qBAAA;AAMJ;;AAJA;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAOJ;;AALA;EACI,eAAA;EACA,YAAA;AAQJ;;AANA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AASJ;;AAPA;EACI,eAAA;EACA,cAAA;AAUJ;;AARA;EACI,eAAA;EACA,cAAA;AAWJ;;AARA;EACI;IACI,uBAAA;EAWN;EATE;IACI,aAAA;IACA,WAAA;IACA,eAAA;IACA,uBAAA;EAWN;EATE;IACI,UAAA;EAWN;EATE;IACI,WAAA;EAWN;AACF","sourcesContent":["/* Video */\n.videosubnav {\n    margin-right: 2rem;\n    .activesn {\n        background-color: #1e2c5f;\n        color: #ffff;\n    }\n}\n.videocate {\n    display: flex;\n    font-size: 3rem;\n    color: #ffff;\n    width: 100%;\n}\n.cpacate {\n    background-color: #152046;\n}\n.cmacate {\n    background-color: #2B418E;\n}\n.eacate {\n    background-color: #0abd5a;\n}\n.cateitem {\n    color: #242424;\n    font-size: 1rem;\n    list-style-type:none;\n}\n.cateitem li{\n    list-style-type: none;\n    padding-left: 0;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.cateitem ul {\n    padding-left: 0;\n    margin: auto;\n}\n.videotitle {\n    font-size: 1.2rem;\n    color: #000000;\n    font-weight: 700;\n}\n.videotext {\n    font-size: 12pt;\n    color: #000000;\n}\n.speacher {\n    font-size: 1rem;\n    color: #000000;\n}\n\n@media (max-width:1200px) {\n    .mvarea {\n        justify-content: center;\n    }\n    .videocate {\n        display: flex;\n        width: 100%;\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n    .mvideocard {\n        width: 80%;\n    }\n    .videosubnav {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
